import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import Loading from "../../../../components/spinners/Loading";
import { useCreateNewFileDataMutation } from "../../../../features/fileManager/fileManagerApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentOffice } from "../../../../features/auth/authSlice";
import {
  rollbackNewFileDataAxios,
  uploadFileAxios,
} from "../../../../app/api/axios/services/files.service";

export default function UploadFileStep({ data, handleNext }) {
  const [loading, setLoading] = useState(false);
  const [createNewFileData] = useCreateNewFileDataMutation();
  const currentOffice = useSelector(selectCurrentOffice);

  // Removes the just-created metadata record if the subsequent file upload
  // fails, so we never leave an orphaned filedata entry behind. Wrapped so a
  // rollback failure never masks the original error.
  const rollbackOrphan = async (fileId) => {
    if (!fileId) {
      return;
    }
    try {
      await rollbackNewFileDataAxios(fileId);
    } catch (rollbackError) {
      console.error("Error rolling back filedata:", rollbackError.message);
    }
  };

  const handleUpload = async () => {
    setLoading(true);
    // Build a fresh fileDetails object instead of mutating the shared state
    // object. Mutating data.fileDetails caused the extension to be appended
    // again on every retry (e.g. "name.docx.docx") and is unsafe React state.
    const fileDetails = {
      ...data.fileDetails,
      fileName: `${data.fileDetails.fileName}${data.fileDetails.extension ?? ""}`,
      type: data.docType ?? "SONSTIGES",
    };
    let createdFileId = null;
    try {
      let resultNewFileData = await createNewFileData({
        directory: data?.directory,
        fileDetails,
        officeRef: currentOffice,
      }).unwrap();
      if (resultNewFileData && resultNewFileData?.type === "SUCCESS") {
        // Metadata created
        createdFileId = resultNewFileData.fileData?._id;
        // Upload file
        const formData = new FormData();
        formData.append("file", data.file);
        let resultUploadFile = await uploadFileAxios(formData, createdFileId);
        if (resultUploadFile.status === 200) {
          // File upload was successful
          setLoading(false);
          handleNext();
          return;
        }
      }
      // Metadata was created but the file upload did not succeed: roll back the
      // orphan record, then re-enable the button so the user can retry.
      await rollbackOrphan(createdFileId);
      setLoading(false);
    } catch (error) {
      // Handle upload error
      console.error("Error uploading file:", error.message);
      await rollbackOrphan(createdFileId);
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div>
        <div style={{ minWidth: 300, minHeight: 300 }}>
          <Loading />
        </div>
        <div>
          <Typography sx={{ mt: 6, p: 2 }} textAlign={"center"} variant="h3">
            Bitte warten, das Dokument wird hochgeladen...
          </Typography>
        </div>
      </div>
    );

  return (
    <div>
      <Button
        variant="contained"
        onClick={handleUpload}
        disabled={loading}
        fullWidth
        sx={{ padding: "25px" }}
        style={{ fontSize: "150%" }}
      >
        DOKUMENT HOCHLADEN
      </Button>
    </div>
  );
}
